import { render, staticRenderFns } from "./Sider.vue?vue&type=template&id=640b0aa8&scoped=true"
import script from "./Sider.vue?vue&type=script&lang=js"
export * from "./Sider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b0aa8",
  null
  
)

export default component.exports